import { useGetEnrollment } from "@/api/generated/enrollments/enrollments";

// One request per enrollment: the dashboard role check and the pages it wraps
// share the generated cache key.
export const useEnrollment = (enrollmentId: string | undefined) =>
  useGetEnrollment(enrollmentId ?? "", {
    swr: { enabled: Boolean(enrollmentId) },
  });
